import { Tooltip } from 'react-aria-components';
import styled from 'styled-components';

export const Overlay = styled(Tooltip)`
  padding: var(--spacing-base) var(--spacing-large);
  background: var(--white);
  border: 0;
  border-radius: var(--radius-large);
  font-size: var(--font-size-text-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--grey-700);
  transform: translate3d(0, 0, 0);
  transition:
    transform 200ms,
    opacity 200ms;

  &[data-entering],
  &[data-exiting] {
    transform: var(--origin);
    opacity: 0;
  }

  & svg {
    display: block;
    width: 15px;
  }

  &[data-placement='top'] {
    margin-bottom: var(--spacing-base);
    box-shadow: var(--shadow-overlay);

    --origin: translateY(-4px);

    & svg {
      margin-block-start: -1px;
    }
  }

  &[data-placement='bottom'] {
    margin-top: var(--spacing-base);
    box-shadow: 0 -4px 6px -2px rgb(10 13 18 / 0.03), 0 -12px 16px -4px rgb(10 13 18 / 0.08);

    --origin: translateY(-4px);

    & svg {
      margin-block-end: -1px;
      transform: rotate(180deg);
    }
  }

  &[data-placement='right'] {
    margin-inline-start: var(--spacing-base);
    box-shadow: -4px 0 6px -2px rgb(10 13 18 / 0.03), -12px 0 16px -4px rgb(10 13 18 / 0.08);

    --origin: translateX(-4px);

    & svg {
      margin-inline-end: -5px;
      transform: rotate(90deg);
    }
  }

  &[data-placement='left'] {
    margin-inline-end: var(--spacing-base);
    box-shadow: 4px 0 6px -2px rgb(10 13 18 / 0.03), 12px 0 16px -4px rgb(10 13 18 / 0.08);

    --origin: translateX(4px);

    & svg {
      margin-inline-start: -5px;
      transform: rotate(-90deg);
    }
  }
`;
